import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { WireApiService } from '../services';

@Injectable({
  providedIn: 'root',
})
class PermissionsService {
  readonly router = inject(Router);
  readonly wireApiService = inject(WireApiService);

  canActivate(): boolean {
    if (!this.wireApiService.hasCredentials) {
      return true;
    }
    this.router.navigateByUrl('/');
    return false;
  }
}

export const AntiAuthGuard: CanActivateFn = () => {
  return inject(PermissionsService).canActivate();
};
